import React, { useState } from 'react';
import { MountainSnowIcon, MapPinIcon, PhoneIcon, MailIcon, FacebookIcon, InstagramIcon, TwitterIcon, YoutubeIcon, ArrowRightIcon } from 'lucide-react';
export function Footer() {
  const [email, setEmail] = useState('');
  return <>
      {/* ─── Immersive CTA Banner ─── */}
      <section className="relative w-full overflow-hidden" data-id="element-63">
        <div className="absolute inset-0" data-id="element-64">
          <img src="https://images.unsplash.com/photo-1605649487212-47bdab064df7?w=1920&q=80" alt="Himalayan mountain sunset panorama" className="w-full h-full object-cover" data-id="element-65" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70" data-id="element-66" />
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 py-28 sm:py-36 text-center" data-id="element-67">
          <span className="inline-block text-[#D4A853] text-sm font-medium tracking-[0.3em] uppercase mb-5" data-id="element-68">
            Begin Your Journey
          </span>
          <h2 className="font-playfair text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-69">
            Ready to Experience
            <br data-id="element-70" />
            <span className="italic font-medium" data-id="element-71">Nepal in Luxury?</span>
          </h2>
          <p className="text-white/70 text-lg sm:text-xl font-light max-w-2xl mx-auto mb-10" data-id="element-72">
            Let our travel experts craft your perfect Himalayan adventure
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-73">
            <a href="#contact" className="inline-flex items-center px-8 py-4 bg-teal-600 text-white font-medium rounded-full hover:bg-teal-700 transition-all duration-300 shadow-xl shadow-teal-900/30 text-sm tracking-wide" data-id="element-74">
              Plan Your Trip
            </a>
            <a href="tel:+9779851032316" className="inline-flex items-center gap-2 px-8 py-4 border border-white/40 text-white font-medium rounded-full hover:bg-white/10 transition-all duration-300 text-sm tracking-wide" data-id="element-75">
              <PhoneIcon className="w-4 h-4" data-id="element-76" />
              Call Us: +977 9851032316
            </a>
          </div>
        </div>
      </section>

      {/* ─── Main Footer ─── */}
      <footer id="contact" className="w-full bg-[#0a0f1a] text-white" data-id="element-77">
        {/* Top Bar — Logo + Nav */}
        <div className="border-b border-slate-800/60" data-id="element-78">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-79">
            <a href="#" className="flex items-center gap-2.5" data-id="element-80">
              <MountainSnowIcon className="w-5 h-5 text-teal-400" data-id="element-81" />
              <span className="font-playfair text-lg font-semibold text-white" data-id="element-82">
                Nepal Luxury Travel
              </span>
            </a>
            <nav aria-label="Footer navigation" data-id="element-83">
              <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2" data-id="element-84">
                <li data-id="element-85">
                  <a href="#trips" className="text-slate-400 text-sm hover:text-white transition-colors duration-300" data-id="element-86">
                    Trips
                  </a>
                </li>
                <li className="text-slate-700 hidden sm:block" data-id="element-87">·</li>
                <li data-id="element-88">
                  <a href="#hotels" className="text-slate-400 text-sm hover:text-white transition-colors duration-300" data-id="element-89">
                    Hotels
                  </a>
                </li>
                <li className="text-slate-700 hidden sm:block" data-id="element-90">·</li>
                <li data-id="element-91">
                  <a href="#about" className="text-slate-400 text-sm hover:text-white transition-colors duration-300" data-id="element-92">
                    About
                  </a>
                </li>
                <li className="text-slate-700 hidden sm:block" data-id="element-93">·</li>
                <li data-id="element-94">
                  <a href="#blog" className="text-slate-400 text-sm hover:text-white transition-colors duration-300" data-id="element-95">
                    Blog
                  </a>
                </li>
                <li className="text-slate-700 hidden sm:block" data-id="element-96">·</li>
                <li data-id="element-97">
                  <a href="#reviews" className="text-slate-400 text-sm hover:text-white transition-colors duration-300" data-id="element-98">
                    Reviews
                  </a>
                </li>
                <li className="text-slate-700 hidden sm:block" data-id="element-99">·</li>
                <li data-id="element-100">
                  <a href="#contact" className="text-slate-400 text-sm hover:text-white transition-colors duration-300" data-id="element-101">
                    Contact
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        {/* Middle — 4 Column Grid */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-id="element-102">
          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8" data-id="element-103">
            {/* Destinations */}
            <div data-id="element-104">
              <h3 className="text-white font-semibold text-xs uppercase tracking-[0.15em] mb-6" data-id="element-105">
                Destinations
              </h3>
              <ul className="space-y-2.5" data-id="element-106">
                <li data-id="element-107">
                  <a href="#" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-108">
                    Kathmandu Valley
                  </a>
                </li>
                <li data-id="element-109">
                  <a href="#" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-110">
                    Everest Region
                  </a>
                </li>
                <li data-id="element-111">
                  <a href="#" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-112">
                    Annapurna
                  </a>
                </li>
                <li data-id="element-113">
                  <a href="#" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-114">
                    Chitwan
                  </a>
                </li>
                <li data-id="element-115">
                  <a href="#" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-116">
                    Upper Mustang
                  </a>
                </li>
                <li data-id="element-117">
                  <a href="#" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-118">
                    Pokhara
                  </a>
                </li>
              </ul>
            </div>

            {/* Experiences */}
            <div data-id="element-119">
              <h3 className="text-white font-semibold text-xs uppercase tracking-[0.15em] mb-6" data-id="element-120">
                Experiences
              </h3>
              <ul className="space-y-2.5" data-id="element-121">
                <li data-id="element-122">
                  <a href="#" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-123">
                    Luxury Trekking
                  </a>
                </li>
                <li data-id="element-124">
                  <a href="#" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-125">
                    Wildlife Safari
                  </a>
                </li>
                <li data-id="element-126">
                  <a href="#" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-127">
                    Cultural Tours
                  </a>
                </li>
                <li data-id="element-128">
                  <a href="#" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-129">
                    Helicopter Tours
                  </a>
                </li>
                <li data-id="element-130">
                  <a href="#" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-131">
                    Wellness Retreats
                  </a>
                </li>
                <li data-id="element-132">
                  <a href="#" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-133">
                    Photography Tours
                  </a>
                </li>
              </ul>
            </div>

            {/* Company */}
            <div data-id="element-134">
              <h3 className="text-white font-semibold text-xs uppercase tracking-[0.15em] mb-6" data-id="element-135">
                Company
              </h3>
              <ul className="space-y-2.5" data-id="element-136">
                <li data-id="element-137">
                  <a href="#about" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-138">
                    About Us
                  </a>
                </li>
                <li data-id="element-139">
                  <a href="#" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-140">
                    Our Team
                  </a>
                </li>
                <li data-id="element-141">
                  <a href="#" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-142">
                    Sustainability
                  </a>
                </li>
                <li data-id="element-143">
                  <a href="#" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-144">
                    Careers
                  </a>
                </li>
                <li data-id="element-145">
                  <a href="#" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-146">
                    Press
                  </a>
                </li>
                <li data-id="element-147">
                  <a href="#" className="text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-148">
                    Partners
                  </a>
                </li>
              </ul>
            </div>

            {/* Get in Touch */}
            <div data-id="element-149">
              <h3 className="text-white font-semibold text-xs uppercase tracking-[0.15em] mb-6" data-id="element-150">
                Get in Touch
              </h3>
              <ul className="space-y-4 mb-6" data-id="element-151">
                <li className="flex items-start gap-2.5" data-id="element-152">
                  <MapPinIcon className="w-4 h-4 text-teal-500 mt-0.5 flex-shrink-0" data-id="element-153" />
                  <span className="text-slate-500 text-sm leading-relaxed" data-id="element-154">
                    Thamel, Kathmandu
                    <br data-id="element-155" />
                    Nepal 44600
                  </span>
                </li>
                <li data-id="element-156">
                  <a href="tel:+9779851032316" className="flex items-center gap-2.5 text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-157">
                    <PhoneIcon className="w-4 h-4 text-teal-500 flex-shrink-0" data-id="element-158" />
                    +977 9851032316
                  </a>
                </li>
                <li data-id="element-159">
                  <a href="mailto:info@nepalluxurytravel.com" className="flex items-center gap-2.5 text-slate-500 text-sm hover:text-teal-400 transition-colors duration-300" data-id="element-160">
                    <MailIcon className="w-4 h-4 text-teal-500 flex-shrink-0" data-id="element-161" />
                    info@nepalluxurytravel.com
                  </a>
                </li>
              </ul>

              {/* Newsletter */}
              <p className="text-slate-600 text-xs uppercase tracking-wider font-medium mb-3" data-id="element-162">
                Newsletter
              </p>
              <form onSubmit={e => {
              e.preventDefault();
              setEmail('');
            }} className="flex" data-id="element-163">
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Your email address" aria-label="Email address for newsletter" className="flex-1 min-w-0 px-4 py-2.5 bg-slate-900 border border-slate-800 rounded-l-lg text-sm text-white placeholder:text-slate-600 focus:outline-none focus:border-teal-600 transition-colors" data-id="element-164" />
                <button type="submit" aria-label="Subscribe to newsletter" className="px-3.5 py-2.5 bg-teal-600 rounded-r-lg hover:bg-teal-700 transition-colors duration-300" data-id="element-165">
                  <ArrowRightIcon className="w-4 h-4 text-white" data-id="element-166" />
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800/60" data-id="element-167">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-168">
            <p className="text-slate-600 text-xs" data-id="element-169">
              © 2026 Nepal Luxury Travel. All rights reserved.
            </p>

            {/* Social Icons */}
            <div className="flex items-center gap-4" data-id="element-170">
              <a href="#" aria-label="Facebook" className="text-slate-600 hover:text-white transition-colors duration-300" data-id="element-171">
                <FacebookIcon className="w-4 h-4" data-id="element-172" />
              </a>
              <a href="#" aria-label="Instagram" className="text-slate-600 hover:text-white transition-colors duration-300" data-id="element-173">
                <InstagramIcon className="w-4 h-4" data-id="element-174" />
              </a>
              <a href="#" aria-label="Twitter" className="text-slate-600 hover:text-white transition-colors duration-300" data-id="element-175">
                <TwitterIcon className="w-4 h-4" data-id="element-176" />
              </a>
              <a href="#" aria-label="YouTube" className="text-slate-600 hover:text-white transition-colors duration-300" data-id="element-177">
                <YoutubeIcon className="w-4 h-4" data-id="element-178" />
              </a>
            </div>

            <div className="flex items-center gap-4 text-slate-600 text-xs" data-id="element-179">
              <a href="#" className="hover:text-slate-300 transition-colors duration-300" data-id="element-180">
                Privacy Policy
              </a>
              <span data-id="element-181">·</span>
              <a href="#" className="hover:text-slate-300 transition-colors duration-300" data-id="element-182">
                Terms of Service
              </a>
              <span data-id="element-183">·</span>
              <a href="#" className="hover:text-slate-300 transition-colors duration-300" data-id="element-184">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>;
}